import { render, staticRenderFns } from "./cg-info.vue?vue&type=template&id=2839045d&scoped=true&"
import script from "./cg-info.vue?vue&type=script&lang=js&"
export * from "./cg-info.vue?vue&type=script&lang=js&"
import style0 from "./cg-info.vue?vue&type=style&index=0&id=2839045d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2839045d",
  null
  
)

export default component.exports